/*
 * View for showing a task to complete in the reviewer UI
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/reviewer/reviewerArea/template/reviewerAreaTemplate.html",
  "modules/typeahead/typeaheadModel",
  "modules/tasks/tasksModel",
], function ($, Marionette, Messenger, ReviewerAreaTemplate, typeaheadModel, TaskModel) {
  const ReviewerAreaView = {};

  const tooltipDelay = {
    show: 333,
    hide: 0,
  };

  ReviewerAreaView.reviewerAreaLayout = Marionette.Layout.extend({
    template: ReviewerAreaTemplate,
    className: "max-height",
    textboxes: function () {
      let userResults;
      return {
        "#reviewerUserSearchText": {
          enableSelector: "#reviewerUserSearch",
          modelAttribute: "user",
          placeholder: "topic.review.noUserAssigned",
          doNotModifyPlaceholder: true,
          textArea: false,
          model: "reviewerAreaTask",
          doNotAllowEmpty: true,
          emptyTextboxMessage: "topic.tasks.assigneeEmpty",
          typeahead: {
            source: (query, process) => {
              userResults = Messenger.reqres.request("usersWithId:typeahead", query);
              userResults.once("sync", function () {
                process(
                  userResults.map(function (result) {
                    return result.get("text");
                  }),
                );
              });
            },
            updater: (item) => {
              const userResult = userResults.findWhere({ text: item });
              if (userResult) {
                // Must wait, otherwise the closing of the typeahead will overwrite the value
                setTimeout(() => {
                  this.model.set("userId", userResult.get("id"));
                  this.model.set("user", userResult.get("text"));
                  if (this.model.reviewerAreaTask) {
                    this.model.reviewerAreaTask.set("userId", userResult.get("id"));
                    this.model.reviewerAreaTask.set("user", userResult.get("text"));
                  }
                }, 100);
                return userResult.get("text");
              }
              this.model.set("userId", 0);
              this.model.set("user", "");
              return "";
            },
          },
        },
      };
    },
    onRender: function () {
      //Standard stuff
      //internationalize the html
      this.$el.i18n();
      //apply tooltips
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: tooltipDelay, container: "body" });
      //apply textboxes defined in this.textboxes
      this._applyTextboxes();
    },
    regions: {
      responseProperties: "#responseProperties",
      responsePreview: "#responsePreview", //using the same id as in the topic page for CSS similarity
      categories: "#categoryContentList",
      categoriesHeader: "#category-Header",
      topicAttributes: "#attTab",
      examples: "#examplesTab",
      uploads: "#uploadsTab",
    },
    triggers: {
      "click #reviewNameLink": "show:topic",
      "click #approveReview": "complete:review",
      "click #completeUpdate": "complete:update",
      "click #rejectUpdate": "reject:update",
      "click #rejectReview": "reject:review",
      "click #startProgress": "start:progress",
      "click .btn-add-comment": "add:comment",
    },
    events: {
      "change #reviewerUserSearchText": function () {
        const user = this.$el.find("#textBoxField").val();
        // If the assigned user input is empty, revert back to previous assignee
        if (!user || user.length === 0) {
          this.trigger("reset:task:user");
        }
      },
      // Cannot use triggers for these, even though all they do is trigger an event, because
      // triggers will cancel any other listeners and that prevents bootstrap from properly
      // handling the tab panel events.
      "click #attLink": function () {
        this.trigger("show:attributes");
      },
      "click #catLink": function () {
        this.trigger("show:categories");
      },
      "click #responseLink": function () {
        this.trigger("show:preview");
      },
      "click #examplesLink": function () {
        this.trigger("show:examples");
      },
      "click #uploadsLink": function () {
        this.trigger("show:uploads");
      },
    },
    modelEvents: {
      "validate:touchpoint:permission": function (permission) {
        if (permission) {
          this.$el.find("#userPermissionError").hide();
        } else {
          const errorMessage = $.t("task.noTouchpointPermission");
          this.$el
            .find("#userPermissionError")
            .html('<h5 class="error-message">' + errorMessage + "</h5>")
            .hide()
            .fadeIn();
        }
      },
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateUtc:short", date);
      },
      isCompleted: function (task) {
        return (
          task.get("status") === TaskModel.STATUS.COMPLETED ||
          task.get("status") === TaskModel.STATUS.FAILED ||
          task.get("status") === TaskModel.STATUS.IGNORED ||
          task.get("status") === TaskModel.STATUS.RESUBMITTED
        );
      },
    },
    hideCategoriesTab: function () {
      this.$el.find("#catLi").addClass("hidden");
    },
    setAssignee: function (user) {
      this.$el.find("#textBoxField").val(user);
    },
    showCategoriesTab: function () {
      this.$el.find("#catLi").removeClass("hidden");
    },
    showAttributes: function () {
      this.$el.find("#attLi").removeClass("hidden");
    },
  });

  return ReviewerAreaView;
});
